import { render, staticRenderFns } from "./MSignup.vue?vue&type=template&id=21bbf18a&scoped=true"
import script from "./MSignup.vue?vue&type=script&lang=js"
export * from "./MSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bbf18a",
  null
  
)

export default component.exports